import Toolbar from "@mui/material/Toolbar";
import { currPathValue } from "../../types/enums";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { ArrowBack } from "@mui/icons-material";
import { alpha, styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import Button from "@mui/material/Button";
import InfoIcon from '@mui/icons-material/Info';
import Popover from "@mui/material/Popover";
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { fields, mapFieldToText } from "../../lang/constants";

const tag = "__APP_VERSION__";
interface FrontPageToolbarProps {
        currentPath: currPathValue;
        previousPath: currPathValue[];
        header: string;
        goBack: () => void;
        doDocumentSearch: (value:string) => void;
        getListData: (value:currPathValue) => void;
      }

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(0em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const navItems = [currPathValue.Recent, currPathValue.Favorites, currPathValue.Activities];

export const FrontPageToolbar = (props:FrontPageToolbarProps) => {
    const [searchInput, setSearchInput] = React.useState<string>("");
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleSearchInputChange = (searchInput: string) => {
        setSearchInput(searchInput);
      };

    const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
      };

    const handleClose = () => {
        setAnchorEl(null);
      };

    const open = Boolean(anchorEl);

    if(props.currentPath === currPathValue.Document || props.currentPath === currPathValue.WfActivity)
    {
        return <Toolbar>
                    <Box sx={{ flexGrow: 1, paddingRight: '10px'}}>
                        <IconButton
                        edge="end"
                        aria-label="go back"
                        onClick= {() => props.goBack()}
                        color="inherit"
                        >
                        <ArrowBack />
                        </IconButton>  
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        {props.header}
                    </Box>
            </Toolbar>
    }
    else
    {
        return <Toolbar>            
                    <Box sx={{ flexGrow: 1}}>
                        <Box sx={{ display: 'flex', p: 1}}>
                            <Search>
                                {/* <SearchIconWrapper > */}
                                <IconButton 
                                    edge="end"
                                    aria-label="do search"
                                    onClick={()=>props.doDocumentSearch(searchInput)}
                                    color="inherit"
                                >
                                    <SearchIcon  />
                                </IconButton>
                                <StyledInputBase
                                placeholder={mapFieldToText(fields.SEARCH)}
                                inputProps={{ 'aria-label': 'search' }}
                                value={searchInput} 
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleSearchInputChange(event.target.value);}}
                                onKeyDown={e => e.key === 'Enter' ? props.doDocumentSearch(searchInput) : ''}
                                />
                            </Search>
                            <IconButton
                              edge="end"
                              aria-label="go back"
                              onClick={(event: React.MouseEvent<HTMLButtonElement>)=>openPopover(event)}
                              color="inherit"
                              sx={{ ml: 'auto', paddingLeft: '10px' }}
                              >
                                <InfoIcon />
                            </IconButton>  
                        </Box>
                        <Box sx={{ display: 'block'}}> 
                            <Box sx={{ flexGrow: 1}}>
                                {navItems.map((item) => (
                                <Button key={item} sx={{ flexGrow: 1, color: '#fff', width: '32%', border: '1px solid white', padding: '2px', margin: '2px' }} onClick={() => props.getListData(item)}>
                                    {mapFieldToText(item===currPathValue.Recent ? fields.RECENT : 
                                                        item===currPathValue.Favorites ? fields.FAVORITES : fields.ACTIVITIES
                                    )}
                                </Button>
                                ))}
                            </Box>
                        </Box>
                        <Popover
                            id="info-popover"
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}
                        >
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                            <IconButton
                              edge="end"
                              aria-label="go back"
                              onClick={() => handleClose()}
                              color="inherit"
                              sx={{ ml: 'auto' }}
                            >
                              <CloseIcon />
                            </IconButton>  
                          </Box>
                          <Box sx={{ flexGrow: 1, padding: '10px' }}>
                              <Typography variant="h6"><b>Release {tag}</b></Typography>
                              <Typography variant="h6">Created by: ML</Typography>
                              {/* <Typography variant="h6">Created by: Martynas L.</Typography>
                              <Typography variant="h6">Requested by: nobody</Typography>
                              <Typography variant="h6">Functionality: N/A</Typography> */}
                          </Box>
                        </Popover>
                    </Box>
                </Toolbar>
    }

    
}
